import { configStore, documentStore, uiStore } from "@/store/store";
import { keyboardShortcuts } from "./keyboard-shortcuts";
import { openElementCustomCssAndFocusCodeMirror } from "./open-element-css";
import { openElementClassAutocompleteAndFocusIt } from "./open-element-class-autocomplete";
import {
  maybeEnableSearchBoxModifiedToggle,
  maybeFocusASearchBox
} from "./search";

export const KEYBOARD_SHORTCUTS = {
  CMD_A: ["command+a", "ctrl+a"],
  CMD_B: ["command+b", "ctrl+b"],
  CMD_E: ["command+e", "ctrl+e"],
  CMD_S: ["command+s", "ctrl+s"],
  CMD_Z: ["command+z", "ctrl+z"],
  CMD_SHIFT_Z: ["command+shift+z", "ctrl+shift+z"],
  // These are handled by copy-paste.ts
  CMD_C: ["command+c", "ctrl+c"],
  //  CMD_X: ["command+x", "ctrl+x"],
  CMD_V: ["command+v", "ctrl+v"],
  CMD_D: ["command+d", "ctrl+d"],
  ESC: ["esc"],
  BACKSPACE: ["backspace"],
  DELETE: ["delete"],
  CMD_OPTION_R: ["command+option+r", "ctrl+alt+r"],
  CMD_SLASH: ["command+/", "ctrl+/"],
  CMD_SHIFT_SLASH: ["command+shift+/", "ctrl+shift+/"],
  CMD_QUESTION: ["command+?", "ctrl+?"],
  CMD_SHIFT_S: ["command+shift+s", "ctrl+shift+s"],
  SHIFT_ESC: ["shift+esc"],
  C_S_S: ["c s s"],
  C_L_A: ["c l a"],
  F: ["f"],
  SHIFT_F: ["shift+f"],
  CMD_I: ["command+i", "ctrl+i"],
  OPTION_P: ["alt+p"]
};

export const registerGlobalShortcuts = () => {
  return {
    register() {
      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.ESC, () => {
        /*
        we want this shortcut to do two things, depending on the context:
         - if the a popout section is open, esc should close it
         - otherwise, esc should de-activate the active element

         i couldn't figure out a proper way to do that...
         trying to use keyboardShortcuts.register in the Dropdown component
         just overrides this shortcut. trying to manually listen to a keyboard
         event in the Dropdown component doesn't work either because this library
         catches it first.

         so i implemented this hack.
         */
        if (
          document.dispatchEvent(
            new CustomEvent("close-dropdowns-when-escape-is-pressed", {
              cancelable: true
            })
          )
        ) {
          if (uiStore.isPreviewMode) {
            uiStore.closePreviewMode();
          } else {
            uiStore.activateElement(null);
          }
        }
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.BACKSPACE, () => {
        uiStore.activeElementId &&
          documentStore.deleteElement({ nodeId: uiStore.activeElementId });
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_D, () => {
        if (uiStore.activeElementId) {
          documentStore.duplicateElementAndActivateIt(uiStore.activeElementId);
        }
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_OPTION_R, () => {
        uiStore.selectNextBreakpoint();
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_SHIFT_SLASH, () => {
        uiStore.setKeyboardShortcutHelpModalOpen(true);
      });
      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_SLASH, () => {
        uiStore.setKeyboardShortcutHelpModalOpen(true);
      });

      keyboardShortcuts.register("e l e m e n t", () => {
        configStore.setElementStudioPowerUser(true);
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.C_S_S, () => {
        openElementCustomCssAndFocusCodeMirror();
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.C_L_A, () => {
        openElementClassAutocompleteAndFocusIt();
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.F, () => {
        maybeFocusASearchBox();
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.SHIFT_F, () => {
        maybeFocusASearchBox(true);
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.SHIFT_F, () => {
        maybeFocusASearchBox(true);
      });

      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_I, () => {
        maybeEnableSearchBoxModifiedToggle();
      });
      keyboardShortcuts.register(KEYBOARD_SHORTCUTS.OPTION_P, () => {
        uiStore.togglePreviewMode();
      });
    },
    unbind() {
      keyboardShortcuts.unbind("e l e m e n t");

      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.ESC);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_D);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.BACKSPACE);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_OPTION_R);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_SHIFT_SLASH);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_SLASH);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.C_S_S);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.C_L_A);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.F);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.SHIFT_F);
      keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_I);
    }
  };
};
